// Route definitions only; the schemas they refer to stay out of the web bundle.
import { defineRoute } from './route.ts';
import type { authConfigResponse, localLoginBody, logoutResponse, meResponse } from './auth.ts';

export const getMe = defineRoute<{ response: typeof meResponse }>()({ method: 'GET', path: '/api/me' });
export const getAuthConfig = defineRoute<{ response: typeof authConfigResponse }>()({ method: 'GET', path: '/api/auth/config' });
export const localLogin = defineRoute<{ body: typeof localLoginBody; response: typeof meResponse }>()({
  method: 'POST',
  path: '/api/auth/local/login',
});
export const logout = defineRoute<{ response: typeof logoutResponse }>()({ method: 'POST', path: '/auth/logout' });
